import { useTranslation } from "react-i18next";
import { FileUpload } from "../FileUpload";
import { FileTypeEnum, FileUpload as FileUploadType } from "../../types";

interface JustificationDocsFormProps {
  token?: string;
  disabled?: boolean;
  idPassportFiles: FileUploadType[];
  setIdPassportFiles: (files: FileUploadType[]) => void;
  weddingDivorceFiles: FileUploadType[];
  setWeddingDivorceFiles: (files: FileUploadType[]) => void;
  policeRcFiles: FileUploadType[];
  setPoliceRcFiles: (files: FileUploadType[]) => void;
  policeRcError?: string;
}

export const JustificationDocsForm: React.FC<JustificationDocsFormProps> = ({
  token,
  disabled = false,
  idPassportFiles,
  setIdPassportFiles,
  weddingDivorceFiles,
  setWeddingDivorceFiles,
  policeRcFiles,
  setPoliceRcFiles,
  policeRcError,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <p className="font-bold text-off-black text-[20px]">{t("form.documents.title")}</p>
      <div className="flex flex-col gap-[24px]">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <FileUpload
            type={FileTypeEnum.ID_PASSPORT}
            label={t("form.documents.idPassport")}
            files={idPassportFiles}
            onFilesChange={setIdPassportFiles}
            disabled={disabled}
            token={token}
          />
          <FileUpload
            type={FileTypeEnum.WEDDING_DIVORCE}
            label={t("form.documents.marriageDivorce")}
            files={weddingDivorceFiles}
            onFilesChange={setWeddingDivorceFiles}
            disabled={disabled}
            token={token}
          />
        </div>
        <div className="flex gap-4">
          <FileUpload
            type={FileTypeEnum.POLICE_RC}
            label={t("form.documents.policeRc")}
            files={policeRcFiles}
            onFilesChange={setPoliceRcFiles}
            disabled={disabled}
            required
            error={policeRcError}
            token={token}
          />
        </div>
      </div>
    </>
  );
};
